import React, { useState } from 'react';
import {
  motion,
  useScroll,
  useTransform,
  useReducedMotion
} from 'framer-motion';

interface ShapeConfig {
  src: string;
  alt?: string;
  className: string;      // taille + flou
  containerClass: string; // position initiale top/left/bottom/right
  offset: number;         // amplitude de parallaxe (en px)
}

const shapes: ShapeConfig[] = [
  {
    src: '/img/svg/shapes/flower.svg',
    alt: 'Flower',
    className: 'w-50 h-50 blur-lg',
    containerClass: 'top-[45%] left-[5%]',
    offset:  -360,
  },
  {
    src: '/img/svg/shapes/snake.svg',
    alt: 'Snake',
    className: 'w-35 h-35 blur-xl',
    containerClass: 'top-[10%] left-[22%]',
    offset:  120,
  },
  {
    src: '/img/svg/shapes/flower_green.svg',
    alt: '',
    className: 'w-25 h-25 blur-2xl',
    containerClass: 'bottom-[5%] left-[23%]',
    offset:  280,
  },
  {
    src: '/img/svg/shapes/virus.svg',
    alt: '',
    className: 'w-25 h-25 blur-2xl',
    containerClass: 'bottom-[25%] left-[45%]',
    offset:  270,
  },
  {
    src: '/img/svg/shapes/half_donut.svg',
    alt: '',
    className: 'w-25 h-25 blur-xl',
    containerClass: 'bottom-[-5%] right-[25%]',
    offset: 300,
  },
  {
    src: '/img/svg/shapes/donut.svg',
    alt: '',
    className: 'w-25 h-25 blur-xl',
    containerClass: 'top-[5%] right-[23%]',
    offset:  -250,
  },
  {
    src: '/img/svg/shapes/virus_green.svg',
    alt: '',
    className: 'w-25 h-25 blur-xl',
    containerClass: 'bottom-[33%] right-[6%]',
    offset:  -90,
  },
];

export const ParallaxShapes: React.FC = () => {
  const { scrollYProgress } = useScroll();
  const shouldReduce = useReducedMotion();

  // Génère un multiplicateur aléatoire [1,3) pour chaque shape, une seule fois
  const [multipliers] = useState<number[]>(() =>
    shapes.map(() => Math.random() * 2 + 1)
  );
  
  return (
    <div className="parallax-shapes absolute inset-0 flex overflow-visible">
      <div className="relative w-full h-full overflow-hidden">
        <div
          className="
            absolute top-0
            left-1/2 transform -translate-x-1/2
            w-[2620px] h-full
          "
        >
          {shapes.map((shape, i) => {
            const mult = multipliers[i];
            // si on réduit les animations, on ne bouge pas :
            const y = shouldReduce
              ? 0 
              : useTransform(
                  scrollYProgress, 
                  [0, 1],
                  [ -shape.offset, +shape.offset * mult ]
                );

            return (
              <motion.img
                key={i}
                src={shape.src}
                alt={shape.alt || ''}
                className={`
                  absolute
                  ${shape.className}
                  ${shape.containerClass}
                `}
                // style inline pour y ; top,left… restent gérés par Tailwind
                style={{ y }}
                // on ne veut pas de "pop" au montage
                initial={false}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ParallaxShapes;
